document.addEventListener("DOMContentLoaded", () => {
  const staticHeader = document.querySelector(".header--static");
  const stickyHeader = document.querySelector(".header--sticky");
  const headerWrapper = document.querySelector(".header-wrapper");
  if (!staticHeader || !stickyHeader || !headerWrapper) return;

  let lastScrollY = window.scrollY;
  let headerHeight = staticHeader.offsetHeight;
  const isAboutUsPage = headerWrapper.classList.contains(
    "header-wrapper--about-us",
  );

  // Function to reinitialize menu drawer functionality for all menu icons
  const reinitializeMenuDrawer = () => {
    const menuIcons = document.querySelectorAll(".header__heading-menu-icon");
    const overlay = document.querySelector(".menu-drawer-overlay");
    const panel = document.querySelector(".menu-drawer-panel");
    const closeBtn = document.querySelector(".menu-drawer-close");

    if (menuIcons.length > 0 && overlay && panel && closeBtn) {
      // Ensure overlay has higher z-index than sticky header
      overlay.style.zIndex = "10000";

      // Remove existing listeners and add new ones to all menu icons
      menuIcons.forEach((menuIcon) => {
        // Clone to remove existing event listeners
        const newMenuIcon = menuIcon.cloneNode(true);
        menuIcon.parentNode.replaceChild(newMenuIcon, menuIcon);

        // Add click listener
        newMenuIcon.addEventListener("click", () => {
          // Open drawer using same logic as menu drawer snippet
          overlay.classList.remove("tw-hidden");
          overlay.classList.add("tw-flex");
          document.body.classList.add("tw-overflow-hidden");

          requestAnimationFrame(() => {
            panel.classList.remove("tw--translate-x-full");
            panel.classList.add("tw-translate-x-0");
          });

          // Force a reflow to ensure styles are applied
          void overlay.offsetWidth;
        });
      });

      // Reinitialize close button
      const newCloseBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

      const closeDrawer = () => {
        panel.classList.remove("tw-translate-x-0");
        panel.classList.add("tw--translate-x-full");

        setTimeout(() => {
          overlay.classList.add("tw-hidden");
          overlay.classList.remove("tw-flex");
          document.body.classList.remove("tw-overflow-hidden");
        }, 300);
      };

      newCloseBtn.addEventListener("click", closeDrawer);

      // Reinitialize overlay click to close (no need to clone since overlay has no listeners)
      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) {
          closeDrawer();
        }
      });
    }
  };

  // Function to handle scroll
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const scrollDirection = currentScrollY > lastScrollY ? "down" : "up";

    // Hide sticky header when scrolling down past header height
    if (scrollDirection === "down" && currentScrollY > headerHeight) {
      staticHeader.style.visibility = "visible";
      stickyHeader.style.display = "none";
      // Reset sticky header styles
      stickyHeader.style.position = "";
      stickyHeader.style.top = "";
      stickyHeader.style.left = "";
      stickyHeader.style.right = "";
      stickyHeader.style.zIndex = "";
      stickyHeader.style.backdropFilter = "";
      stickyHeader.style.webkitBackdropFilter = "";
      stickyHeader.style.background = "";
      stickyHeader.style.boxShadow = "";
      stickyHeader.style.borderBottom = "";
      stickyHeader.style.width = "";
      stickyHeader.style.paddingTop = "";
      stickyHeader.style.paddingBottom = "";
      stickyHeader.style.height = "";
    }
    // Show sticky header when scrolling up and past header height
    else if (scrollDirection === "up" && currentScrollY > headerHeight) {
      // Keep static header visible for layout
      staticHeader.style.visibility = "hidden";
      stickyHeader.style.display = "flex";
      stickyHeader.style.position = "fixed";
      stickyHeader.style.top = "0";
      stickyHeader.style.left = "0";
      stickyHeader.style.right = "0";
      stickyHeader.style.zIndex = "9999";
      stickyHeader.style.backdropFilter = "blur(12px)";
      stickyHeader.style.webkitBackdropFilter = "blur(12px)";

      // Apply different styling for About Us page
      if (isAboutUsPage) {
        stickyHeader.style.background = "#ffffff";
        stickyHeader.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.2)";
        stickyHeader.style.borderBottom = "1px solid rgba(255, 255, 255, 0.1)";
      } else {
        stickyHeader.style.background = "#ffffff";
        stickyHeader.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
        stickyHeader.style.borderBottom = "1px solid rgba(0, 0, 0, 0.05)";
      }

      stickyHeader.style.width = "100%";
      stickyHeader.style.paddingTop = "20px !important";
      stickyHeader.style.paddingBottom = "20px !important";
      stickyHeader.style.height = "auto";

      // Reinitialize menu drawer to work with both headers
      reinitializeMenuDrawer();

      // Reinitialize cart drawer accessibility for sticky header cart icon
      const cartDrawer = document.querySelector("cart-drawer");
      if (
        cartDrawer &&
        typeof cartDrawer.setHeaderCartIconAccessibility === "function"
      ) {
        cartDrawer.setHeaderCartIconAccessibility();
      }
    }
    // Hide sticky header when at top of page
    else if (currentScrollY <= headerHeight) {
      staticHeader.style.visibility = "visible";
      stickyHeader.style.display = "none";
      // Reset sticky header styles
      stickyHeader.style.position = "";
      stickyHeader.style.top = "";
      stickyHeader.style.left = "";
      stickyHeader.style.right = "";
      stickyHeader.style.zIndex = "";
      stickyHeader.style.backdropFilter = "";
      stickyHeader.style.webkitBackdropFilter = "";
      stickyHeader.style.background = "";
      stickyHeader.style.boxShadow = "";
      stickyHeader.style.borderBottom = "";
      stickyHeader.style.width = "";
      stickyHeader.style.paddingTop = "";
      stickyHeader.style.paddingBottom = "";
      stickyHeader.style.height = "";
    }

    lastScrollY = currentScrollY;
  };

  // Listen for scroll events
  window.addEventListener("scroll", handleScroll, { passive: true });

  // Initial check
  handleScroll();
});
